import React, { PropsWithChildren } from 'react';
import { Ribbon } from './PerfectRibbon.styled';

export type RibbonPosition =
  | 'top-left'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-right';

export type RibbonProps = PropsWithChildren<{
  position: RibbonPosition;
}>;

export const PerfectRibbon = ({
  position,
  children,
  ...otherProps
}: RibbonProps): JSX.Element => {
  return (
  // eslint-disable-next-line react/jsx-props-no-spreading
    <Ribbon $position={ position } { ...otherProps }>
      {children}
    </Ribbon>
  );
};
